import React from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { CheckboxLabelWithController } from '~components/reuseable/CheckboxLabelWithController';
import { OutlinedInputWithController } from '~components/reuseable/OutlinedInputWithController';
import { SurveyFormKeyEnum } from '~modules/surveys/forms/SurveyForm';
import { SurveyExtraQuestionModel } from '~modules/surveys/models/SurveyExtraQuestionModel';
import { SurveyQuestionModel } from '~modules/surveys/models/SurveyQuestionModel';

interface ICheckboxGroupQuestionProps {
  name: string;
}

export const CheckboxGroupQuestion: React.FC<ICheckboxGroupQuestionProps> = (props) => {
  const { control } = useFormContext();

  const currentValue: SurveyQuestionModel | SurveyExtraQuestionModel = useWatch({ name: props.name, control });

  const { t } = useTranslation('survey');

  // Render

  return (
    <>
      {currentValue.answers.map(({ answerId, descr, isTextAnswer, isChecked }, index) => {
        const isShowTextField = isChecked && isTextAnswer;

        return (
          <div key={answerId}>
            <CheckboxLabelWithController
              name={`${props.name}.answers.[${index}].${SurveyFormKeyEnum.isChecked}`}
              label={descr}
              hookFormProps={{ control }}
            />
            {isShowTextField && (
              <OutlinedInputWithController
                name={`${props.name}.answers.[${index}].${SurveyFormKeyEnum.textValue}`}
                hookFormProps={{ control }}
                fullWidth
                multiline
                rows={2}
                label={t('input.specify.label')}
                required
                hideErrorMessage
              />
            )}
          </div>
        );
      })}
    </>
  );
};
